"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const query_1 = require("../codec/Switcheo/carbon/adl/query");
const query_2 = require("../codec/Switcheo/carbon/book/query");
const query_3 = require("../codec/Switcheo/carbon/broker/query");
const query_4 = require("../codec/Switcheo/carbon/cdp/query");
const query_5 = require("../codec/Switcheo/carbon/coin/query");
const query_6 = require("../codec/cosmos/auth/v1beta1/query");
const query_7 = require("../codec/cosmos/bank/v1beta1/query");
const query_8 = require("../codec/Switcheo/carbon/bank/query");
const query_9 = require("../codec/Switcheo/carbon/bridge/query");
const query_10 = require("../codec/cosmos/base/tendermint/v1beta1/query");
const query_11 = require("../codec/cosmos/distribution/v1beta1/query");
const query_12 = require("../codec/cosmos/evidence/v1beta1/query");
const query_13 = require("../codec/cosmos/gov/v1/query");
const query_14 = require("../codec/cosmos/group/v1/query");
const query_15 = require("../codec/cosmos/mint/v1beta1/query");
const query_16 = require("../codec/cosmos/params/v1beta1/query");
const query_17 = require("../codec/cosmos/slashing/v1beta1/query");
const query_18 = require("../codec/cosmos/staking/v1beta1/query");
const query_19 = require("../codec/cosmos/upgrade/v1beta1/query");
const query_20 = require("../codec/ethermint/evm/v1/query");
const query_21 = require("../codec/cosmos/authz/v1beta1/query");
const query_22 = require("../codec/cosmos/feegrant/v1beta1/query");
const query_23 = require("../codec/Switcheo/carbon/evmmerge/query");
const query_24 = require("../codec/Switcheo/carbon/evmbank/query");
const query_25 = require("../codec/ethermint/feemarket/v1/query");
const query_26 = require("../codec/Switcheo/carbon/fee/query");
const query_27 = require("../codec/Switcheo/carbon/headersync/query");
const query_28 = require("../codec/ibc/applications/interchain_accounts/controller/v1/query");
const query_29 = require("../codec/ibc/applications/interchain_accounts/host/v1/query");
const query_30 = require("../codec/ibc/applications/transfer/v1/query");
const query_31 = require("../codec/ibc/core/client/v1/query");
const query_32 = require("../codec/ibc/core/connection/v1/query");
const query_33 = require("../codec/ibc/core/channel/v1/query");
const query_34 = require("../codec/Switcheo/carbon/inflation/query");
const query_35 = require("../codec/Switcheo/carbon/insurance/query");
const query_36 = require("../codec/Switcheo/carbon/leverage/query");
const query_37 = require("../codec/Switcheo/carbon/liquidation/query");
const query_38 = require("../codec/Switcheo/carbon/liquiditypool/query");
const query_39 = require("../codec/Switcheo/carbon/market/query");
const query_40 = require("../codec/Switcheo/carbon/marketstats/query");
const query_41 = require("../codec/Switcheo/carbon/misc/query");
const query_42 = require("../codec/Switcheo/carbon/oracle/query");
const query_43 = require("../codec/Switcheo/carbon/order/query");
const query_44 = require("../codec/Switcheo/carbon/position/query");
const query_45 = require("../codec/Switcheo/carbon/pricing/query");
const query_46 = require("../codec/Switcheo/carbon/profile/query");
const query_47 = require("../codec/Switcheo/carbon/subaccount/query");
const query_48 = require("../codec/alliance/alliance/query");
const query_49 = require("../codec/Switcheo/carbon/perpspool/query");
const query_50 = require("../codec/Switcheo/carbon/erc20/query");
const stargate_1 = require("@cosmjs/stargate");
const BlockchainClient_1 = __importDefault(require("./BlockchainClient"));
class CarbonQueryClient {
    constructor(opts) {
        var _a;
        const rpcClient = (_a = opts.grpcClient) !== null && _a !== void 0 ? _a : stargate_1.createProtobufRpcClient(new stargate_1.QueryClient(opts.tmClient));
        this.chain = BlockchainClient_1.default.connectWithTm(opts.tmClient);
        this.adl = new query_1.QueryClientImpl(rpcClient);
        this.alliance = new query_48.QueryClientImpl(rpcClient);
        this.book = new query_2.QueryClientImpl(rpcClient);
        this.bridge = new query_9.QueryClientImpl(rpcClient);
        this.broker = new query_3.QueryClientImpl(rpcClient);
        this.coin = new query_5.QueryClientImpl(rpcClient);
        this.cdp = new query_4.QueryClientImpl(rpcClient);
        this.fee = new query_26.QueryClientImpl(rpcClient);
        this.inflation = new query_34.QueryClientImpl(rpcClient);
        this.insurance = new query_35.QueryClientImpl(rpcClient);
        this.leverage = new query_36.QueryClientImpl(rpcClient);
        this.liquidation = new query_37.QueryClientImpl(rpcClient);
        this.liquiditypool = new query_38.QueryClientImpl(rpcClient);
        this.market = new query_39.QueryClientImpl(rpcClient);
        this.marketstats = new query_40.QueryClientImpl(rpcClient);
        this.misc = new query_41.QueryClientImpl(rpcClient);
        this.oracle = new query_42.QueryClientImpl(rpcClient);
        this.order = new query_43.QueryClientImpl(rpcClient);
        this.position = new query_44.QueryClientImpl(rpcClient);
        this.pricing = new query_45.QueryClientImpl(rpcClient);
        this.profile = new query_46.QueryClientImpl(rpcClient);
        this.subaccount = new query_47.QueryClientImpl(rpcClient);
        this.headersync = new query_27.QueryClientImpl(rpcClient);
        this.evmmerge = new query_23.QueryClientImpl(rpcClient);
        this.evmbank = new query_24.QueryClientImpl(rpcClient);
        this.perpspool = new query_49.QueryClientImpl(rpcClient);
        this.auth = new query_6.QueryClientImpl(rpcClient);
        this.bank = new query_7.QueryClientImpl(rpcClient);
        this.nativeBank = new query_8.QueryClientImpl(rpcClient);
        this.distribution = new query_11.QueryClientImpl(rpcClient);
        this.evidence = new query_12.QueryClientImpl(rpcClient);
        this.grant = new query_21.QueryClientImpl(rpcClient);
        this.feegrant = new query_22.QueryClientImpl(rpcClient);
        this.group = new query_14.QueryClientImpl(rpcClient);
        this.gov = new query_13.QueryClientImpl(rpcClient);
        this.mint = new query_15.QueryClientImpl(rpcClient);
        this.params = new query_16.QueryClientImpl(rpcClient);
        this.slashing = new query_17.QueryClientImpl(rpcClient);
        this.staking = new query_18.QueryClientImpl(rpcClient);
        this.upgrade = new query_19.QueryClientImpl(rpcClient);
        this.cosmosTm = new query_10.ServiceClientImpl(rpcClient);
        this.alliance = new query_48.QueryClientImpl(rpcClient);
        this.erc20 = new query_50.QueryClientImpl(rpcClient);
        this.ibc = {
            controller: new query_28.QueryClientImpl(rpcClient),
            host: new query_29.QueryClientImpl(rpcClient),
            transfer: new query_30.QueryClientImpl(rpcClient),
            client: new query_31.QueryClientImpl(rpcClient),
            connection: new query_32.QueryClientImpl(rpcClient),
            channel: new query_33.QueryClientImpl(rpcClient),
        };
        this.ethermint = {
            evm: new query_20.QueryClientImpl(rpcClient),
            feeMarket: new query_25.QueryClientImpl(rpcClient),
        };
    }
}
exports.default = CarbonQueryClient;
